import React from 'react';
import 'antd/dist/antd.css';
import html2canvas from 'html2canvas';
import './index.scss';
import { Spin, Table } from 'antd';
import SVGIcons from '../../Components/SVGIcons';
import {
    topicsColumn,
    responsesColumn,
    NON_CHANGEABLE_KEYS_FOR_DOWNLOAD,
    HYPHEN,
    HEATMAP_IMAGE_DOWNLOAD_ID,
    HEATMAP_SHEET_NAMES,
} from './constants';
import { addColumnProperties, customExpandIcon, getColouredExcelSheet } from "./heatmapConfig"
import GraphLoader from '../ContentLoaders/GraphLoader';
import { HeatmapHeaders } from './heatmapHeaders';
import { deepCopy } from '../../utils/deepCopy';
import { EmptyState } from '../../Packages/EmptyState';
import { enableMouseDrag } from './mouseDrag';
import { Excel } from 'antd-table-saveas-excel';
import { getDataFromUrlToken } from '../../utils/urlDataStore';
import { URL_DATA } from "../../../config/urlDataConstants";
import { ButtonElement } from '../../FormElements/ButtonElement';


export class HeatmapV2 extends React.Component {
    constructor(props) {
        super(props);
        this.printRef = React.createRef();
        this.state = {
            collapsedColumns: [],
            keys: [],
            showScores: true,
            hideColors: false,
            downloadImage: false,
            projectDetails: getDataFromUrlToken(URL_DATA.PROJECT_DETAILS)

        };
        enableMouseDrag(this.props.id);
    }

    getHeatmapColoumns = (columnsFromBackend) => {
        let backendColumns = deepCopy(columnsFromBackend);
        let heatmapColumns = [topicsColumn, responsesColumn, ...backendColumns];
        return heatmapColumns
    }

    appendStaticColumnsFromUI = (columnsFromBackend) => {
        let backendColumns = deepCopy(columnsFromBackend);
        let heatmapColumns = this.state.downloadImage ? [{
            //default static first column
            title: '',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            isStatic: true,
        }, responsesColumn, ...backendColumns] : [topicsColumn, responsesColumn, ...backendColumns];
        heatmapColumns = this.addCustomElementsToColumnData(heatmapColumns);
        return heatmapColumns;
    };

    componentDidUpdate() {
        if (this.props.showTableLoader && this.state.keys && this.state.keys.length) {
            this.resetTopicQuestions()
        }
    }

    addCustomElementsToColumnData = (columnData) => {
        let data = columnData;
        data = data.map((item) => {
            let parentColumn = item;
            parentColumn.isParent = true
            if (!item.isStatic) {
                if (this.state.collapsedColumns.includes(parentColumn.dataIndex)) {
                    parentColumn.children = [];
                    parentColumn.isCollapse = true
                } else {
                    let childrenDataMapping = this.props.childColumns.find(
                        (item) => item.dataIndex === parentColumn.dataIndex
                    )
                    parentColumn.children = childrenDataMapping &&
                        childrenDataMapping.children ? childrenDataMapping.children : [];
                    parentColumn.title = childrenDataMapping && childrenDataMapping.title
                    parentColumn.isCollapse = false
                }
            }
            parentColumn = this.addPropertiesToParentAndChildrenColumns(parentColumn);
            parentColumn.onHeaderCell = (cell) => {
                return {
                    onClick: () => this.toggleHeaderCollapse(cell),
                };
            };
            return parentColumn;
        });
        return data;
    };

    toggleHeaderCollapse = (cell) => {
        if (
            !this.state.collapsedColumns.includes(cell.dataIndex) &&
            cell.children &&
            cell.children.length
        ) {
            this.setState({
                collapsedColumns: [...this.state.collapsedColumns, cell.dataIndex],
            });
        } else {
            let collapsedColumns = this.state.collapsedColumns;
            if (collapsedColumns.includes(cell.dataIndex)) {
                collapsedColumns.splice(collapsedColumns.indexOf(cell.dataIndex), 1);
            }
            this.setState({ collapsedColumns: collapsedColumns });
        }
    };

    addPropertiesToParentAndChildrenColumns = (column) => {
        if (column) {
            let modifiedColumn = column;
            modifiedColumn.className = this.getColumnClassName(modifiedColumn.dataIndex);
            modifiedColumn = addColumnProperties(
                modifiedColumn, this.props.selectedHeaders,
                {
                    showScores: this.state.showScores,
                    hideColors: this.state.hideColors,
                    isCustomPalette: this.props.heatmapConfiguration ? true : false,
                    heatmapConfiguration: this.props.heatmapConfiguration,
                    isTrendHeatmap: this.props.isTrendHeatmap,
                    selectedLevel: this.props.selectedLevel,
                    projectDetails: this.state.projectDetails
                });
            modifiedColumn.onCell = (record, index) =>
                this.onCell(modifiedColumn.dataIndex, index);
            if (modifiedColumn.children) {
                modifiedColumn.children = modifiedColumn.children.map(
                    this.addPropertiesToParentAndChildrenColumns
                );
            }
            return modifiedColumn;
        }
    };

    onCell = (dataIndex, index) => {
        return {
            //uncomment to bring flicker colour when hover

            // onMouseEnter: (event) => {
            //     let allCells = document.getElementsByClassName('ant-table-cell');
            //     let elements = document.getElementsByClassName(this.getColumnClassName(dataIndex));
            //     if (elements && elements.length) {
            //         setTimeout(() => {
            //             for (let i = 0; i < allCells.length; i++) {
            //                 allCells[i].classList.add('in-active');
            //                 elements[i] && elements[i].classList.add('active');
            //             }
            //         }, 0);
            //     }
            // }, // mouse enter row
            // onMouseLeave: (event) => {
            //     let allCells = document.getElementsByClassName('ant-table-cell');
            //     if (allCells && allCells.length) {
            //         setTimeout(() => {
            //             for (let i = 0; i < allCells.length; i++) {
            //                 allCells[i].classList.remove('in-active');
            //                 allCells[i].classList.remove('active');
            //             }
            //         }, 0);
            //     }
            // }, // mouse leave row
        };
    };

    headersWithoutByScore = (headers) => {
        if (headers && headers.length > 0) {
            return headers.filter(this.isByScoreOrMultipleSelect)
        } else {
            return headers
        }
    }

    isByScoreOrMultipleSelect = (value) => {
        if (value.content === "byScore" || value.content === "multipleSelect") {
            return false
        }
        else {
            return true
        }

    }

    getHeatmapHeaders = () => {
        return <HeatmapHeaders
            isTrendHeatmap={this.props.isTrendHeatmap}
            heatmapType={this.props.heatmapType}
            headers={this.headersWithoutByScore(this.props.headers)}
            selectedHeaders={this.props.selectedHeaders}
            onSelectHeader={this.props.onSelectHeader}
            resetTopicQuestions={this.resetTopicQuestions}
            onToggleShowScores={this.onToggleShowScores}
            onToggleHideColors={this.onToggleHideColors}
            showScores={this.state.showScores}
            hideColors={this.state.hideColors}
            selectedScoreLevel={this.props.selectedScoreLevel}
            scoreLevelList={this.props.scoreLevelList}
            onChangeScoreType={this.props.onChangeScoreType}
            comparisonLevelList={this.props.comparisonLevelList}
            selectedLevel={this.props.selectedLevel}
            onChangeComparisonLevel={this.props.onChangeComparisonLevel}

        />
    }

    onToggleShowScores = (value) => {
        this.setState({ showScores: !value })
    }

    onToggleHideColors = (value) => {
        this.setState({ hideColors: !value })
    }

    getColumnClassName = (dataIndex) => {
        return dataIndex.replaceAll(' ', '-')
    }

    onExpandHeatMap = (expanded, record) => {
        var keys = deepCopy(this.state.keys);
        if (expanded) {
            keys.push(record.key);
            this.setState({ keys });
            let dimension = record.name
            let columns = this.props.selectedHeaders
            this.props.onExpand(dimension, columns)
        } else {
            keys = keys.filter(item => item !== record.key)
            this.setState({ keys });
        }
    };

    resetTopicQuestions = () => {
        this.setState({ keys: [] });
    }

    handleExport = () => {
        let backendColumns = deepCopy(this.props.columns);
        const csvColoumns = [{
            "title": "",
            "dataIndex": "name",
            "key": "name",
            "fixed": "left",
            "width": 200,
            "isStatic": true,
            "isParent": true,
            "className": "name"


        },
        {
            "title": "overall score",
            "dataIndex": "score",
            "key": "score",
            "isStatic": true,
            "isResponses": true,
            "isParent": true,
            "className": "score"
        }, ...backendColumns
        ]
        const projectDetails = getDataFromUrlToken(URL_DATA.PROJECT_DETAILS)
        let projectName = projectDetails && projectDetails.projectName ? `${projectDetails.projectName}-heatmap` : "heatmap"
        const excel = new Excel();
        excel.defaultTheadCellStyle = { ...excel.defaultTheadCellStyle, background: "ffffff", v: "center", h: "center", fontName: "Inter" }
        excel.defaultTbodyCellStyle = { ...excel.defaultTbodyCellStyle, border: true, v: "center", h: "center", fontName: "Inter" }
        if (this.props.isMultipleSheetsNeeded) {
            let sheets = this.updatedExpandedData()

            const multiSheetColumns = [
                [...csvColoumns],
                [{
                    ...csvColoumns[0],
                    title: "Subcategory"
                },
                ...csvColoumns.slice(1)],
                [{
                    "title": HEATMAP_SHEET_NAMES[0] || "Parent from sheet 1",
                    "dataIndex": "parentLevel0Name",
                    "key": "parentLevel0Name",
                    "fixed": "left",
                    "width": 200,
                    "isStatic": true,
                    "isParent": true,
                    "className": "parent-level-0-name"
                },
                {
                    "title": HEATMAP_SHEET_NAMES[1] || "Parent from sheet 2",
                    "dataIndex": "parentLevel1Name",
                    "key": "parentLevel1Name",
                    "fixed": "left",
                    "width": 200,
                    "isStatic": true,
                    "isParent": true,
                    "className": "parent-level-1-name",
                    excelStyle: {
                        alignment: {
                            horizontal: "left",
                            vertical: "bottom"
                        }
                    }

                },
                {
                    ...csvColoumns[0],
                    title: "Behavior"
                },
                ...csvColoumns.slice(1)],
            ]
            if (sheets && sheets.length) {
                sheets.forEach((sheet, index) => {
                    if (!sheet || !sheet.rows || !sheet.rows.length) {
                        return
                    }

                    excel.addSheet(sheet.sheetName)
                    excel.addColumns(multiSheetColumns[index])
                    excel.addDataSource(sheet.rows)

                    if (!this.state.hideColors) {
                        excel.sheet = getColouredExcelSheet(excel.sheet, this.props.heatmapConfiguration, this.props.isTrendHeatmap, this.state.showScores, index === 2 ? 3 : 1)
                    }
                })
            }
        } else {
            let updatedData = this.updatedExpandedData()
            excel.addSheet('Heatmap')
            excel.addColumns(csvColoumns)
            excel.addDataSource(updatedData)
            if (!this.state.hideColors) {
                excel.sheet = getColouredExcelSheet(excel.sheet, this.props.heatmapConfiguration, this.props.isTrendHeatmap, this.state.showScores)
            }
        }


        excel.saveAs(`${projectName}.xlsx`);
    }

    updatedExpandedData = () => {
        let datas = deepCopy(this.props.data);
        if (!this.props.isMultipleSheetsNeeded) {
            let updatedArray = []
            datas.forEach(element => {
                let scoreElement = this.getScoredElement(element)
                updatedArray.push(scoreElement)
                if (element.children && element.children.length > 0) {
                    this.childrensData(element.children, updatedArray, element)
                }
            });
            return updatedArray
        } else {
            let levelsData = []

            datas.forEach(element => {
                let scoreElement = this.getScoredElement(element)

                if (!levelsData[0]) {
                    levelsData[0] = []
                }
                levelsData[0].push({
                    ...scoreElement,
                    parentLevel0Name: element.name,
                    parentLevel1Name: null
                })

                if (element.children && element.children.length > 0) {
                    this.childrensDataForMultipleSheets(element.children, 1, levelsData, [element.name])
                }
            });

            let sheets = []
            levelsData.forEach((rows, levelIndex) => {
                if (!rows || !rows.length) {
                    return
                }
                let sheetName = HEATMAP_SHEET_NAMES[levelIndex] ? HEATMAP_SHEET_NAMES[levelIndex] : `Heatmap - Children Level ${levelIndex}`
                sheets.push({ sheetName, rows })
            })

            return sheets
        }

    }

    childrensDataForMultipleSheets = (newdatas, level, levelsData, ancestors) => {
        newdatas.forEach(expandedData => {
            let updatedScore = this.getScoredElement(expandedData)
            let row = {
                ...updatedScore,
                name: expandedData.name,
                parentLevel0Name: ancestors && ancestors[0] ? ancestors[0] : null,
                parentLevel1Name: ancestors && ancestors[1] ? ancestors[1] : null
            }

            if (!levelsData[level]) {
                levelsData[level] = []
            }
            levelsData[level].push(row)

            if (expandedData.children && expandedData.children.length > 0) {
                const nextAncestors = ancestors ? [...ancestors, expandedData.name] : [expandedData.name]
                this.childrensDataForMultipleSheets(expandedData.children, level + 1, levelsData, nextAncestors)
            }
        })
    }

    childrensData = (newdatas, updatedArray, element) => {
        newdatas.forEach(expandedData => {
            let updatedScore = this.getScoredElement(expandedData)
            let rowName = this.props.isMultipleSheetsNeeded
                ? expandedData.name
                : `${element.name} : ${expandedData.name}`

            updatedArray.push({ ...updatedScore, name: rowName })
            if (expandedData.children && expandedData.children.length > 0) {
                this.childrensData(
                    expandedData.children,
                    updatedArray,
                    this.props.isMultipleSheetsNeeded ? expandedData : { name: rowName }
                )
            }
        })
    }


    getScoredElement = (element) => {
        let elementCopy = deepCopy(element)
        if (element.name !== "Responses") {
            Object.keys(elementCopy).forEach(item => {
                if (!(NON_CHANGEABLE_KEYS_FOR_DOWNLOAD.includes(item))) {
                    if (this.state.hideColors) {
                        if (!this.state.showScores) {
                            if (this.props.isTrendHeatmap) {
                                return this.calculateTrendHeatmapDataForDownload({ item, elementCopy })
                            }
                            else {

                                elementCopy[item] = elementCopy[item] - elementCopy.score
                            }
                        }
                    }
                    else {
                        if (elementCopy[item] !== HYPHEN) {
                            if (!this.state.showScores) {
                                if (this.props.isTrendHeatmap) {
                                    return this.calculateTrendHeatmapDataForDownload({ item, elementCopy, isColored: true })

                                }
                                else {
                                    elementCopy[item] = `${elementCopy[item] - elementCopy.score}|${elementCopy.score}|${elementCopy[item]}`

                                }
                            }
                            else {
                                if (this.props.isTrendHeatmap) {
                                    if ((!item.includes(this.state.projectDetails.projectId))) {

                                        let splittedValue = item.split("/**")
                                        let currentProjectValue = elementCopy[`${splittedValue[0]}/**${this.state.projectDetails.projectName}_${this.state.projectDetails.projectId}`]


                                        elementCopy[item] = `${elementCopy[item]}|${elementCopy.score}currentScore${currentProjectValue}`
                                    }
                                }
                                else {
                                    //adding a | to understand and to use the corresponding colour based on the items original score

                                    elementCopy[item] = `${elementCopy[item]}|${elementCopy.score}`

                                }



                            }
                        }

                    }

                }
            })
        }
        return elementCopy
    }

    calculateTrendHeatmapDataForDownload = ({ item, elementCopy, isColored }) => {
        if (this.props.selectedLevel && this.props.selectedLevel && this.props.selectedLevel.some((projectId => item.includes(projectId)))) {
            let splittedValue = item.split("/**")
            let currentProjectValue = elementCopy[`${splittedValue[0]}/**${this.state.projectDetails.projectName}_${this.state.projectDetails.projectId}`]
            if (splittedValue && splittedValue[0] && currentProjectValue !== undefined) {
                if (currentProjectValue === HYPHEN || elementCopy[item] === HYPHEN) {
                    return elementCopy
                }
                else {
                    if (isColored) {
                        if (typeof currentProjectValue === "string" && currentProjectValue.includes("|")) {
                            let slicedData = currentProjectValue.split("|")
                            currentProjectValue = slicedData[0] ? slicedData[0] : elementCopy.score
                        }
                        elementCopy[item] = `${currentProjectValue - elementCopy[item]}|${elementCopy.score}|${elementCopy[item]}currentScore${currentProjectValue}`

                    }
                    else {
                        elementCopy[item] = currentProjectValue - elementCopy[item]
                    }
                }
            }
        }
        else {
            if (isColored && !item.includes(this.state.projectDetails.projectId)) {
                let splittedValue = item.split("/**")
                let currentProjectValue = elementCopy[`${splittedValue[0]}/**${this.state.projectDetails.projectName}_${this.state.projectDetails.projectId}`]
                elementCopy[item] = `${elementCopy[item]}|${elementCopy.score}|${elementCopy[item]}currentScore${currentProjectValue}`

            }
            return elementCopy
        }
        return elementCopy
    }

    handleImgaeDownload = async () => {
        this.setState({
            downloadImage: true
        })
        setTimeout(async () => {
            const projectDetails = getDataFromUrlToken(URL_DATA.PROJECT_DETAILS)
            let projectName = projectDetails && projectDetails.projectName ? `${projectDetails.projectName}-heatmap` : "heatmap"
            let element = document.getElementsByClassName("ant-table-content")
            let elementById = document.getElementById(this.props.id)
            let index = HEATMAP_IMAGE_DOWNLOAD_ID[this.props.id] ? HEATMAP_IMAGE_DOWNLOAD_ID[this.props.id] : 0
            if (!element[index]) {
                index = index - 1
                if (index < -1) {
                    index = 0
                }
            }
            let width = element[index].scrollWidth + 50
            elementById.style.width = width + "px"
            elementById.style.maxWidth = width + "px"

            elementById.style.padding = "10px"
            const canvas = await html2canvas(elementById, {

                onclone: (element) => {
                }
            });
            const data = canvas.toDataURL(`${projectName}/jpg`);
            const link = document.createElement('a');

            if (typeof link.download === 'string') {
                link.href = data;
                link.download = `${projectName}.jpg`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                elementById.style.width = ""
                elementById.style.maxWidth = ""
                elementById.style.padding = ""
            } else {
                window.open(data);
            }
            this.setState({
                downloadImage: false
            })
        }, 200);

    }


    renderHeatmapTable = () => {
        return (
            <>
                {<div className='downloadsection'>
                    <ButtonElement onClick={this.handleExport} className='download-heatmap'>
                        <SVGIcons type={'SVG-download'} />Download as excel
                    </ButtonElement>

                    <ButtonElement onClick={this.handleImgaeDownload} className='download-heatmap'>
                        <SVGIcons type={'SVG-download'} />Download as jpg
                    </ButtonElement>
                </div>}
                <Spin spinning={this.state.downloadImage}>
                    <Table
                        columns={this.appendStaticColumnsFromUI(this.props.columns)}
                        dataSource={this.props.data}
                        bordered
                        size="middle"
                        className="heatmap-table"
                        id={this.props.id}
                        pagination={false}
                        scroll={{ x: 1000 }}
                        onExpand={this.onExpandHeatMap}
                        expandedRowKeys={this.state.keys}
                        expandIcon={(props) => customExpandIcon(props)}
                    />
                </Spin>
            </>)
    }

    showOutlierSection = () => {
        if (this.props.heatmapOutlier && this.props.heatmapOutlier.data && this.props.selectedHeaders.length === 1 && !this.props.showTableLoader) {
            return true
        }
        return false
    }

    render() {
        return (
            <>
                {this.props.showErrorState ? <EmptyState component={"table"} emptyStateMessage={"No data found"} /> : <>
                    {this.props.showHeadersLoader ?
                        <GraphLoader height={90} width={600} />
                        : !this.props.isHeaderSectionHidden && this.getHeatmapHeaders()
                    }
                    {
                        this.showOutlierSection() && Object.keys(this.props.heatmapOutlier.data).map((item) => <div className='heatmap-outlier'>
                            {this.props.heatmapOutlier.data[item]}
                        </div>)
                    }
                    {this.props.showTableLoader ?
                        <GraphLoader height={300} width={600} />
                        : this.renderHeatmapTable()
                    }
                </>}
            </>
        );
    }
}
